/** Chosen colleagues on the Planübersicht. One list per person and Wochenplan. */
export function weeklyPlanStaffKey(userId: string, instanceId: string): string {
  return `intranet.weekly-plan.staff.${userId}.${instanceId}`;
}

export function readWeeklyPlanStaff(
  storage: Pick<Storage, 'getItem'> | null,
  userId: string,
  instanceId: string,
): string[] {
  if (!storage || userId.length === 0 || instanceId.length === 0) {
    return [];
  }
  const raw = storage.getItem(weeklyPlanStaffKey(userId, instanceId));
  if (!raw) {
    return [];
  }
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [];
    }
    const ids: string[] = [];
    for (const entry of parsed) {
      if (typeof entry === 'string' && entry.length > 0 && !ids.includes(entry)) {
        ids.push(entry);
      }
    }
    return ids;
  } catch {
    return [];
  }
}

export function writeWeeklyPlanStaff(
  storage: Pick<Storage, 'setItem'> | null,
  userId: string,
  instanceId: string,
  userIds: readonly string[],
): void {
  if (!storage || userId.length === 0 || instanceId.length === 0) {
    return;
  }
  storage.setItem(weeklyPlanStaffKey(userId, instanceId), JSON.stringify(userIds));
}
